import React from 'react'
import logoTransparent_beige from 'images/logo_sign_transparent_beige.png'
import './PageHeaderBlock.scss'

const PageHeaderBlock = ({ block }) => {
  return (
    <div className="block block-pageheader">
      <div className="page-header-container">
        <img src={logoTransparent_beige} alt="logo" className="page-header-logo" />
        {block.Heading && <h3>{block.Heading}</h3>}
      </div>
    </div>
  )
}

export default PageHeaderBlock
